import { render, staticRenderFns } from "./UserPurview.vue?vue&type=template&id=5fba320b&scoped=true"
import script from "./UserPurview.vue?vue&type=script&lang=js"
export * from "./UserPurview.vue?vue&type=script&lang=js"
import style0 from "./UserPurview.vue?vue&type=style&index=0&id=5fba320b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba320b",
  null
  
)

export default component.exports